// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-list-status-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: safe center;
  justify-content: center;
  padding: 1.5rem;
  overflow-y: auto;
  background: rgba(18, 16, 26, 0.52);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

.user-list-status-dialog {
  width: min(100%, 480px);
  margin: auto;
  background: #fff;
  color: #1f1b2e;
  border: 1px solid rgba(31, 27, 46, 0.1);
  border-radius: 16px;
  box-shadow: 0 24px 60px rgba(18, 16, 26, 0.28);
  overflow: hidden;
}

.user-list-status-dialog__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 1.25rem 1.4rem 1rem;
  border-bottom: 1px solid rgba(31, 27, 46, 0.1);
  background: linear-gradient(
    180deg,
    rgba(213, 209, 253, 0.35) 0%,
    #fff 100%
  );
}

.user-list-status-dialog__eyebrow {
  margin: 0 0 4px;
  font-size: 12px;
  font-weight: 600;
  color: #6f7588;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 340px;
}

.user-list-status-dialog__title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: #302d45;
}

.user-list-status-dialog__close {
  border: none;
  background: transparent;
  font-size: 1.5rem;
  line-height: 1;
  color: #6f7588;
  cursor: pointer;
  padding: 0 4px;
}

.user-list-status-dialog__close:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.user-list-status-dialog__body {
  padding: 1.15rem 1.4rem 0.5rem;
}

.user-list-status-dialog__intro {
  margin: 0 0 1rem;
  font-size: 13px;
  color: #55515f;
  line-height: 1.45;
}

.user-list-status-dialog__label {
  display: block;
  margin-bottom: 6px;
  font-size: 12px;
  font-weight: 700;
  color: #403b55;
  letter-spacing: 0.2px;
}

.user-list-status-dialog__textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #ddd7ec;
  border-radius: 10px;
  padding: 10px 12px;
  font-size: 13px;
  line-height: 1.45;
  color: #403b55;
  resize: vertical;
  min-height: 110px;
  outline: none;
}

.user-list-status-dialog__textarea:focus {
  border-color: #b0a8e8;
  box-shadow: 0 0 0 3px rgba(213, 209, 253, 0.55);
}

.user-list-status-dialog__counter {
  margin-top: 6px;
  text-align: right;
  font-size: 11px;
  color: #8a8497;
}

.user-list-status-dialog__error {
  margin: 10px 0 0;
  font-size: 13px;
  color: #8a3a3a;
}

.user-list-status-dialog__reason-text {
  margin: 0 0 1rem;
  padding: 12px 14px;
  background: #f7f5fb;
  border-radius: 10px;
  font-size: 13px;
  line-height: 1.5;
  color: #403b55;
  white-space: pre-wrap;
  word-break: break-word;
}

.user-list-status-dialog__footer {
  display: flex;
  gap: 10px;
  padding: 1rem 1.4rem 1.25rem;
}

.user-list-status-dialog__cancel,
.user-list-status-dialog__submit {
  flex: 1 1;
  min-height: 48px;
  border-radius: 11px;
  padding: 11px 20px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition:
    transform 0.15s ease,
    box-shadow 0.2s ease,
    filter 0.2s ease;
}

.user-list-status-dialog__cancel {
  border: 1px solid #e0dce8;
  background: #fff;
  color: #403b55;
}

.user-list-status-dialog__submit {
  border: 1px solid transparent;
  color: #34333b;
}

.user-list-status-dialog__submit--grey {
  background: #f2e6c9;
  border-color: #f2e6c9;
  color: #654343;
}

.user-list-status-dialog__submit--black {
  background: #f2c4c4;
  border-color: #f2c4c4;
  color: #654343;
}

.user-list-status-dialog__cancel:hover,
.user-list-status-dialog__submit:hover:not(:disabled) {
  filter: brightness(0.97);
  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.08);
  transform: translateY(-1px);
}

.user-list-status-dialog__cancel:active,
.user-list-status-dialog__submit:active:not(:disabled) {
  transform: translateY(0) scale(0.99);
  box-shadow: none;
}

.user-list-status-dialog__submit:disabled,
.user-list-status-dialog__cancel:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
  filter: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/UserListStatusModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,uCAAuC;EACvC,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,4BAA4B;EAC5B,8CAA8C;EAC9C;;;;GAIC;AACH;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,4BAA4B;AAC9B;;AAEA;;EAEE,SAAO;EACP,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf;;;oBAGkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,wBAAwB;EACxB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;;EAEE,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd","sourcesContent":[".user-list-status-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: flex;\n  align-items: safe center;\n  justify-content: center;\n  padding: 1.5rem;\n  overflow-y: auto;\n  background: rgba(18, 16, 26, 0.52);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n}\n\n.user-list-status-dialog {\n  width: min(100%, 480px);\n  margin: auto;\n  background: #fff;\n  color: #1f1b2e;\n  border: 1px solid rgba(31, 27, 46, 0.1);\n  border-radius: 16px;\n  box-shadow: 0 24px 60px rgba(18, 16, 26, 0.28);\n  overflow: hidden;\n}\n\n.user-list-status-dialog__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 1.25rem 1.4rem 1rem;\n  border-bottom: 1px solid rgba(31, 27, 46, 0.1);\n  background: linear-gradient(\n    180deg,\n    rgba(213, 209, 253, 0.35) 0%,\n    #fff 100%\n  );\n}\n\n.user-list-status-dialog__eyebrow {\n  margin: 0 0 4px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6f7588;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 340px;\n}\n\n.user-list-status-dialog__title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: #302d45;\n}\n\n.user-list-status-dialog__close {\n  border: none;\n  background: transparent;\n  font-size: 1.5rem;\n  line-height: 1;\n  color: #6f7588;\n  cursor: pointer;\n  padding: 0 4px;\n}\n\n.user-list-status-dialog__close:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.user-list-status-dialog__body {\n  padding: 1.15rem 1.4rem 0.5rem;\n}\n\n.user-list-status-dialog__intro {\n  margin: 0 0 1rem;\n  font-size: 13px;\n  color: #55515f;\n  line-height: 1.45;\n}\n\n.user-list-status-dialog__label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #403b55;\n  letter-spacing: 0.2px;\n}\n\n.user-list-status-dialog__textarea {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid #ddd7ec;\n  border-radius: 10px;\n  padding: 10px 12px;\n  font-size: 13px;\n  line-height: 1.45;\n  color: #403b55;\n  resize: vertical;\n  min-height: 110px;\n  outline: none;\n}\n\n.user-list-status-dialog__textarea:focus {\n  border-color: #b0a8e8;\n  box-shadow: 0 0 0 3px rgba(213, 209, 253, 0.55);\n}\n\n.user-list-status-dialog__counter {\n  margin-top: 6px;\n  text-align: right;\n  font-size: 11px;\n  color: #8a8497;\n}\n\n.user-list-status-dialog__error {\n  margin: 10px 0 0;\n  font-size: 13px;\n  color: #8a3a3a;\n}\n\n.user-list-status-dialog__reason-text {\n  margin: 0 0 1rem;\n  padding: 12px 14px;\n  background: #f7f5fb;\n  border-radius: 10px;\n  font-size: 13px;\n  line-height: 1.5;\n  color: #403b55;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.user-list-status-dialog__footer {\n  display: flex;\n  gap: 10px;\n  padding: 1rem 1.4rem 1.25rem;\n}\n\n.user-list-status-dialog__cancel,\n.user-list-status-dialog__submit {\n  flex: 1;\n  min-height: 48px;\n  border-radius: 11px;\n  padding: 11px 20px;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n  transition:\n    transform 0.15s ease,\n    box-shadow 0.2s ease,\n    filter 0.2s ease;\n}\n\n.user-list-status-dialog__cancel {\n  border: 1px solid #e0dce8;\n  background: #fff;\n  color: #403b55;\n}\n\n.user-list-status-dialog__submit {\n  border: 1px solid transparent;\n  color: #34333b;\n}\n\n.user-list-status-dialog__submit--grey {\n  background: #f2e6c9;\n  border-color: #f2e6c9;\n  color: #654343;\n}\n\n.user-list-status-dialog__submit--black {\n  background: #f2c4c4;\n  border-color: #f2c4c4;\n  color: #654343;\n}\n\n.user-list-status-dialog__cancel:hover,\n.user-list-status-dialog__submit:hover:not(:disabled) {\n  filter: brightness(0.97);\n  box-shadow: 0 5px 14px rgba(0, 0, 0, 0.08);\n  transform: translateY(-1px);\n}\n\n.user-list-status-dialog__cancel:active,\n.user-list-status-dialog__submit:active:not(:disabled) {\n  transform: translateY(0) scale(0.99);\n  box-shadow: none;\n}\n\n.user-list-status-dialog__submit:disabled,\n.user-list-status-dialog__cancel:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n  filter: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
